import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import ls from "local-storage";
import styled from "styled-components";

import falk_ from "../../assets/images/falk_.png";
import icn_img from "../../assets/images/icn.svg";
import pdf_img from "../../assets/images/pdf.svg";
import { Button } from "../ui-kit/styled-templates";

import top_stats_im0 from "../../assets/images/top_stats_im0.png";
import bottom_stats_im0 from "../../assets/images/bottom_stats_im0.png";

import falk_square from "../../assets/images/nek.jpg";
import AmbassadorsList from "../ambassadors/tools/AmbassadorsList";
import PublicAllAmbassadorsPanel from "../ambassadors/panels/PublicAllAmbassadorsPanel";

const AmbassadorsListPage = () => {
    const [bigUrl, setBigUrl] = useState(undefined);

    const { t, i18n } = useTranslation();
    let isRu = i18n.language == "ru";

    useEffect(() => {
        // scroll to top after render and after article loaded
        try{
            setTimeout(() => {
                console.log('scroll to top!!!');
                window.scrollTo({
                    top: 0,
                    behavior: 'auto'
                });
                const element = document.getElementById("header_logo");
                if (element) {
                    element.scrollIntoView({
                        behavior: "auto", // Optional for smooth scrolling
                        block: "start",     // Aligns the element at the top
                    });
                }
            }, 100);
        }catch(exc){

        }
    }, []);

    return (
        <OuterWrapper className={"about_page"}>
            <Wrapper>

                <TopQuote className={'kirkir'} >

                    <LeftFalk className={'kir_left'} >
                        <FalkImg
                            src={falk_square}
                        />
                    </LeftFalk>

                    <TopRightQuote style={{}} className={'kir_right'} >

                        {isRu ?
                            <>
                                Самое важное в путешествиях — люди. В Программе “Студтуризм” мы всегда рядом с теми, кто открывает Россию с интересом и любовью. Амбассадоры именно такие люди. Они объединяют студентов, помогают находить новые маршруты и делают каждое путешествие тёплым и честным. В год, когда мы особенно говорим о единстве, их работа становится примером того, как путешествия могут объединять
                            </>
                            :
                            <>
                                The Studturism Program actively develops youth tourism, promoting cultural exchanges and the establishment of scientific partnerships.
                                Student tourism within its framework expands horizons, allowing not only to travel, but also to participate in educational and scientific initiatives.
                            </>
                        }


                        {/*Влияние этого проекта заметно в трендах развития национального проекта, создающего образованных и глобально мыслящих лидеров, готовых к будущим вызовам.*/}

                        <br />
                        <br />

                        <Falk>
                            {isRu ? 'Руководитель Программы Студтуризм' : 'Head of the Studturism Program'}
                            <br/>
                            <b>
                                {isRu ? 'Нехорошева Светлана' : 'Nekhorosheva Svetlana'}
                            </b>
                        </Falk>
                    </TopRightQuote>
                </TopQuote>

                <NewContent>
                    <TopQuoteDiv style={{marginBottom: 30}} >
                        {isRu ?
                            <>
                                Амбассадоры Программы Студтуризм - вдохновенные исследователи, открывающие молодежи двери в увлекательный мир путешествий и культурных обменов.
                                Эти молодые люди являются не только путешественниками, но и связующим звеном между разными культурами, создавая мосты для научных партнерств и обмена знаний.
                                С их помощью Программа Студтуризм становится источником вдохновения и образования для будущих лидеров.
                            </>
                            :
                            <>
                                Ambassadors of the Studturism Program are inspired researchers who open the doors of youth to the fascinating world of travel and cultural exchanges.
                                These young people are not only travelers, but also a link between different cultures, creating bridges for scientific partnerships and knowledge exchange.
                                With their help, the Studturism Program becomes a source of inspiration and education for future leaders.
                            </>
                        }
                    </TopQuoteDiv>

                    <PublicAllAmbassadorsPanel/>

                    {/*<AmbassadorsList/>*/}

                </NewContent>


            </Wrapper>


        </OuterWrapper>
    );
};

const FirstInnerTd = styled.div`
  padding-right: 30px;
`;

const SecondInnerTd = styled.div`
  opacity: 0.5;
  font-style: italic;
  font-size: 20px;
`;

const TopQuote = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 50px;
`;

const TopRightQuote = styled.div`
  text-align: justify;
  font-family: "Noto Sans", sans-serif;
  font-size: 24px;
  line-height: 32px;
  font-style: italic;
  //margin-bottom: 50px;
  //width: 620px;
  flex: 1
`;

const LeftFalk = styled.div`
  //flex: 1;
  padding-right: 30px;
`;

const FalkImg = styled.img`
  width: 210px;
  height: 210px;
  border-radius: 10px;
  object-fit: cover;
`;

const Falk = styled.div`
  //font-style: italic;
  font-size: 16px;
  text-align: left;
  font-style: normal;
`;

const TopImg = styled.img`
  display: block;
  width: 100%;
  @media (max-width: 820px) {
    display: none;
  }
`;

const GlobalWarningPlaceholder = styled.div`
  position: fixed;
  z-index: 100;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const WhiteBox = styled.div`
  padding: 20px;
  border-radius: 8px;
  text-align: justify;
  background: white;
  width: 620px;
  box-sizing: border-box;
  @media (max-width: 620px) {
    width: calc(100vw - 40px);
    padding: 10px;
  }
`;

const WarningButtonPlaceholder = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LoImg = styled.div`
  width: 240px;
  height: 240px;
  box-sizing: border-box;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${(props) => props.src});
  margin: 10px;
  cursor: pointer;
`;

const Ul = styled.ul`
  box-sizing: border-box;
  padding-left: 15px;
  margin-bottom: 25px;
`;

const Li = styled.li`
  margin-bottom: 10px;
  box-sizing: border-box;
`;

const Heading2 = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 27px;
  color: #212121;
`;

const BLabel = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #212529;
`;

const DownImg = styled.img`
  height: 24px;
  cursor: pointer;
`;

const FileItemHeading = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: #212529;
`;

const FileItemSubHeading = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: #aaaaaa;
`;

const RightContentPlaceholder = styled.div``;

const MyP = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: #212529;
  margin-bottom: 15px;
`;

const FileItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
  cursor: pointer;
`;

const FileItemContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const FileItemLeft = styled.div`
  flex: 1;
`;

const FileItemRight = styled.div``;

const FileImg = styled.img`
  height: 40px;
  margin-right: 8px;
`;

const RightHeading = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 27px;
  font-family: "Noto Sans", sans-serif;
  margin-bottom: 20px;
`;

const Left = styled.div`
  flex: 1;
  @media (max-width: 800px) {
    margin-left: 0px;
    padding: 5px;
  }
`;

const Right = styled.div`
  width: 380px;
  margin-left: 40px;
  @media (max-width: 800px) {
    margin-left: 0px;
    padding: 5px;
  }
`;

const RightBox = styled.div`
  background: #f4f9fc;
  border-radius: 12px;
  box-sizing: border-box;
  padding: 32px;
  margin-bottom: 32px;
  @media (max-width: 800px) {
    padding: 20px;
  }
`;

const TripletPlaceholder = styled.div`
  display: flex;
  flex-direction: row;
  font-family: "Noto Sans", sans-serif;
  margin-top: 40px;
  margin-bottom: 40px;
`;

const TripletHeading = styled.div`
  font-size: 62px;
  line-height: 72px;
  font-weight: bold;
`;

const TripletSub = styled.div`
  font-size: 40px;
  opacity: 0.5;
`;

const TripletItem = styled.div`
  flex: 1;
  padding: 15px;
  text-align: center;
`;

const TopQuoteDiv = styled.div`
  font-family: "Noto Sans", sans-serif !important;  
`;

const NewContent = styled.div`
  font-size: 24px;
  line-height: 32px;
  font-family: "Noto Sans", sans-serif !important;
`;

const ContentPlaceholder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  @media (max-width: 800px) {
    display: block;
  }
`;

const BackLink = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.grey};
  cursor: pointer;
`;

const OuterWrapper = styled.div`
  width: 100%;
  background: white;
  padding-top: 30px;
  box-sizing: border-box;
  padding-bottom: 40px;
`;

const Wrapper = styled.div`
  text-align: left;
  box-sizing: border-box;
  width: 1400px;
  margin: 0 auto;
  padding: 15px;
  font-family: "Noto Sans", sans-serif;
  @media (max-width: 1400px) {
    width: 100%;
  }
`;

const Heading = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 56px;
  line-height: 72px;
  margin-bottom: 40px;
  @media (max-width: 820px) {
    font-size: 24px;
    line-height: 32px;
    padding-left: 5px;
  }
`;

const SupTopPlaceholder = styled.div`
  margin-bottom: 20px;
`;

const TopPlaceholder = styled.div``;

export default AmbassadorsListPage;
